import { CACHING_TIME } from "@/store/utils";
import { EndpointBuilder } from "@reduxjs/toolkit/query";
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from "@reduxjs/toolkit/query";
import { BaseQueryFn } from "@reduxjs/toolkit/query";
import { BatchDetailsResponse, BatchViewResponse } from "../../types";
import {
  UpgradeFWCommandPayload,
  UpgradeFWCommandResponse
} from "../../types/records/rf-fw-upgrade";

export const rfFirmwareUpgradeEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    "rfFWApi"
  >
) => ({
  getBatchList: builder.query<BatchViewResponse, void>({
    query: () => ({
      url: `listbatch`,
      method: "GET"
    }),
    providesTags: [],
    keepUnusedDataFor: CACHING_TIME
  }),
  fetchBatchDetails: builder.mutation<
    BatchDetailsResponse,
    { batch_id: string }
  >({
    query: (data) => ({
      url: "tasksstatus",
      method: "POST",
      body: data
    })
  }),
  executeFWUpgradeCommand: builder.mutation<
    UpgradeFWCommandResponse,
    UpgradeFWCommandPayload
  >({
    query: (data) => ({
      url: `${
        import.meta.env.VITE_HES_BASE_URL
      }/v1/command-execution/execute-rf-firmware-upgrade`,
      method: "POST",
      body: data
    })
  })
});
